// @flow

import copy from 'copy-to-clipboard';
import * as React from 'react';
import Icon from 'sail/Icon';
import Box from 'sail/Box';
import {InlineLink} from 'sail/InlineLink';
import {useToast} from 'docs/hooks';
import './CardNumber.scss';

type CardNumberProps = {|
  number: string,
  copyable?: boolean,
|};

// The way the numbers are grouped/spaced out depends on the total length of the number
// e.g. AMEX card numbers are 15 digits long and look like (3782 123456 12345)
const spacingFormatsByNumberLength = {
  '16': [4, 4, 4, 4],
  '15': [4, 6, 5],
  '14': [4, 6, 4],
};

export const CardNumber = ({number, copyable}: CardNumberProps) => {
  const [toast, showToast] = useToast();
  // Clean number by removing all non-digits
  const cleanedNumber = number.replace(/[\D]/g, '');
  const spacingFormat = spacingFormatsByNumberLength[cleanedNumber.length];

  let currDigit = 0;
  const numberParts = spacingFormat
    ? spacingFormat.map((partLength) => {
        const part = cleanedNumber.substr(currDigit, partLength);
        currDigit += partLength;
        return part;
      })
    : // Fall back to groups of 1-4
      cleanedNumber.match(/[\S]{1,4}/g) || [];

  const onCopy = () => {
    copy(number);
    showToast('Copied!');
  };

  const cardNumber = (
    <span className="CardNumber">
      {numberParts.map((num, idx) => (
        <span key={idx}>{num}</span>
      ))}
    </span>
  );

  if (!copyable) {
    return cardNumber;
  }

  return (
    <React.Fragment>
      <InlineLink
        className="CardNumber-Clipboard"
        onClick={onCopy}
        title="Copy to clipboard"
      >
        {cardNumber}
        <div style={{position: 'relative', display: 'inline-block'}}>
          <Icon
            size={14}
            icon="clipboard"
            color="gray300"
            className="CardNumber-CopyIcon"
            style={{position: 'relative', top: '+1px'}}
          />
          {toast && (
            <Box className="CodeBlock-toast CardNumber-toast">{toast}</Box>
          )}
        </div>
      </InlineLink>
    </React.Fragment>
  );
};
